<template>
    <div>
      <!--Loading-->
      <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>
  
      <PageTitle title="Billing" />

      <div class="summary">
        <div class="child">
            <p class="title-3">Your Subscription</p>
            <p class="title-1">Free Plan</p>
        </div>
        <div class="child">
            <p class="title-3">Monthly Charges</p>
            <p class="title-1">INR 1,500</p>
        </div>
        <div class="child">
            <p class="title-3">Started On</p>
            <p class="title-1">30th October, 2023</p>
        </div>
        <div class="child-right">
            <a class="button is-size-5" style="background: #7409ff; color: #fff;">
                        <strong>Upgrade</strong>
                    </a>
        </div>
      </div>

      <hr/>

      <div class="information">
        <div class="left">
            <p class="title-1">Payment Details</p>
            <p class="title-3">Payment details and Plan History</p>
        </div>
        <div class="right">
            <div class="info-table">
                <div><b>Subscription Status</b></div>
                <div>Active</div>
            </div>
            <div class="info-table">
                <div><b>Next Payment</b></div>
                <div>30th November, 2023</div>
            </div>
            <div class="info-table">
                <div><b>Last Payment</b></div>
                <div>30th October, 2023</div>
            </div>
        </div>
      </div>

      <hr/>

      <div class="information">
        <div class="left">
            <p class="title-1">Cancel Subscription</p>
            <p class="title-3">This action is not reversible. Your plan will be downgraded to free plan. Your progress will get deleted.</p>
        </div>
        <div class="right" style="align-items: center;display: flex;">
            <div class="info-table">
                <div><a class="button is-size-5" style="background: #ff4545; color: #fff;">
                        <strong>Cancel</strong>
                    </a></div>
                
            </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  //Vuex
  import { mapGetters, mapActions } from "vuex";
  import PageTitle from "@/components/PageTitle";
  
  export default {
    name: "Billing",
    components: {
      PageTitle,
    },
    data() {
      return {
        isLoading: false,
        profileModalActive : false,
        current_tab_index : 0
      }
    },
    computed: {
      ...mapGetters(["getTeacherToken", "fetchMyProfile"]),
      currentKidId(){
        let id = null
        if(this.fetchMyProfile.kids.length){
          id = this.fetchMyProfile.kids[this.current_tab_index] ? this.fetchMyProfile.kids[this.current_tab_index] : null
        }
        return id
      }
    },
    methods: {
      ...mapActions(["createQuizMaster", "createCandidate", "loadProfile"]),
      
    },
    async created() {
      this.isLoading = true
      await this.loadProfile({ token : this.getTeacherToken })
      this.isLoading = false
    },
  };
  </script>
  <style scoped>
  .summary{
    background: #c4c4c4;
    display: flex;
    flex-grow: 1;
    padding: 20px 30px;
    justify-content: space-between;
    margin: 50px 0;
  }
  .title-3{
    font-size: 16px;
    font-weight: bold;
  }
  .title-1{
    font-size: 25px;
    font-weight: bold;
  }
  .row-img {
    width: 200px;
  }
  .child-right{
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .information{
    display: flex;
  }
  .left{
    flex-grow: 1;
    width: 100%;
  }
  .right{
    flex-grow: 1;
    width: 100%;
  }
  .info-table{
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
  }
  </style>